import { resolveAssetUrl } from "../utils/assetUrl";

const placeholders = [
  "https://images.unsplash.com/photo-1507537509458-b8312d35a233?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1504598318550-17eba1008a68?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1545239351-1141bd82e8a6?auto=format&fit=crop&w=800&q=80",
];

function prefix(url) {
  if (!url) return url;
  return url.startsWith("/static") ? resolveAssetUrl(url) : url;
}

function PhotoGallery({ photos = [] }) {
  const gallery = photos && photos.length > 0 ? photos : placeholders;

  const hero = prefix(gallery[0]);
  const rest = gallery.slice(1, 5).map(prefix);

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 md:grid-rows-2 gap-2 md:gap-3 rounded-2xl overflow-hidden shadow-lg">
      <div className="md:row-span-2 md:col-span-2 relative">
        <img
          src={hero}
          alt="Salon hero"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-black/10 via-transparent to-transparent" />
      </div>

      {rest.map((src, idx) => (
        <div key={idx} className="relative">
          <img
            src={src}
            alt={`Salon ${idx}`}
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-black/10 via-transparent to-transparent" />
        </div>
      ))}
    </div>
  );
}

export default PhotoGallery;
